import { render, staticRenderFns } from "./testInput.vue?vue&type=template&id=0fef955a&scoped=true&"
import script from "./testInput.vue?vue&type=script&lang=js&"
export * from "./testInput.vue?vue&type=script&lang=js&"
import style0 from "./testInput.vue?vue&type=style&index=0&id=0fef955a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fef955a",
  null
  
)

export default component.exports